import React, { FC } from 'react'
import { HeroOuter, StyledBreadcrumbs } from './style'

//* utils
import { MicrocopySet } from '../../../../models/others/microcopy'
import ImgUtil from '../../../../utils/img.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import { setMetaFields } from './util/setMetaFields'

//* components
import GlobalContainer from '../../../global/globalContainer'
import Typography from '../../../global/typography'
import WrapperImage from '../../../global/wrapperImage'

type Props = {
  microcopy: MicrocopySet | null
  metaInformation: any
  image: any
  pageTitle: string
  h1Title: string
  slug: string
  breadcrumb: any
}

const CustomerStoryHero: FC<Props> = ({
  microcopy,
  metaInformation,
  image,
  pageTitle,
  h1Title,
  slug,
  breadcrumb,
}) => {
  const metaFields = microcopy ? setMetaFields(microcopy, metaInformation) : {}

  return (
    <HeroOuter data-cy="CustomerStoryHero">
      <GlobalContainer className="Hero__Container">
        <div className="Hero__Top-Items">
          {slug && pageTitle && (
            <StyledBreadcrumbs
              backgroundTheme="light"
              currentPathname={`/${slug}`}
              pageName={pageTitle}
              breadcrumb={breadcrumb}
            />
          )}

          <div className="Hero__Logo">
            {metaFields.customerLogoSrc && (
              <WrapperImage
                src={ImgUtil.getResizedImageUrl(metaFields.customerLogoSrc, `width=450`)}
                alt={metaFields.customerLogoAlt}
                className="Hero__Logo-File"
                width={280}
                height={140}
                threshold={650}
              />
            )}
          </div>

          <div className="Hero__Text">
            <div className="Hero__Text-Meta">{metaFields.eyebrows || ''}</div>

            {h1Title && (
              <Typography className="Hero__Text-H1" type="header1">
                {formatInlineCode(h1Title)}
              </Typography>
            )}
          </div>
        </div>

        <div className="Hero__Main-Img-Grid-BG">
          <div className="Hero__Main-Img-Grid-BG-Img"></div>

          <div className="Hero__Main-Img">
            {image?.imageSrc && (
              <WrapperImage
                src={ImgUtil.getResizedImageUrl(image?.imageSrc, `width=1020`)}
                alt={image?.alt}
                className="Hero__Main-Img-File"
                width={588}
                height={330}
                threshold={650}
              />
            )}
          </div>
        </div>
      </GlobalContainer>
    </HeroOuter>
  )
}

export default CustomerStoryHero
